import { MeshDistortMaterial, Sphere } from "@react-three/drei";

import { SphereStyle } from "../BackgroundStyle"
 
export default function SphereObject(props){

  return (
    <mesh position={props.position}>
      <Sphere radius={1}>
        <MeshDistortMaterial 
          attach="material"
          distort={0.81}
          speed={1.8}
          color={SphereStyle.color}
          emissive={SphereStyle.color}
          emissiveIntensity={1}
        />
      </Sphere>

    </mesh>
  );


}